import type { ReactNode } from 'react';
import { Link } from 'react-router';

interface KpiCardProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'default' | 'info' | 'warning' | 'success' | 'danger';
  to?: string;
}

export function KpiCard({ label, value, hint, tone = 'default', to }: KpiCardProps) {
  const content = (
    <>
      <p className="kpi__label">{label}</p>
      <p className="kpi__value">{value}</p>
      {hint && <p className="kpi__hint">{hint}</p>}
    </>
  );
  return to ? (
    <Link className={`kpi kpi--${tone} kpi--link`} to={to}>
      {content}
    </Link>
  ) : (
    <div className={`kpi kpi--${tone}`}>{content}</div>
  );
}
